import {getError} from '@/utils/helpers'
import DefinitionDesBarresStatistiquesConcours from '@/services/DefinitionDesBarresStatistiquesConcoursService'
import {StateDefinitionDesBarresStatistiquesConcours} from '@/types/DefinitionDesBarresStatistiquesConcours'

export const namespaced = true

/* Recup de X */
function getX(note_max: number, classe: number) {
    const getX: any[] = []
    const nbX: number = Math.round(note_max / classe)

    let numberX = 0
    for (let index = 0; index < nbX; index++) {
        getX.push(numberX)
        /* Valeur d affichage de X */
        numberX += classe
    }
    return getX
}

export const state: StateDefinitionDesBarresStatistiquesConcours = {
    infosStatistiquesConcours: [],
    infosStatConcoursTrie: [],
    graphIsLoading: false,
    error: null
}

export const mutations = {
    RESET_STATE(state: StateDefinitionDesBarresStatistiquesConcours): void {
        Object.assign(state, {
            infosStatistiquesConcours: [],
            graphIsLoading: false
        })
    },
    SET_INFOS_STATISTIQUES_CONCOURS(state: StateDefinitionDesBarresStatistiquesConcours, infosStatistiquesConcours: any): void {
        state.infosStatistiquesConcours = infosStatistiquesConcours
    },
    SET_LOADING(state: StateDefinitionDesBarresStatistiquesConcours, isLoading: boolean): void {
        state.graphIsLoading = isLoading
    },
    SET_ERROR(state: StateDefinitionDesBarresStatistiquesConcours, error: Array<any>): void {
        state.error = error
    }
}

export const actions = {
    getInfosStatistiquesConcours({ commit }: { commit: any }, payload?: any) {
        commit('SET_LOADING', true)
        return new Promise((resolve, reject): void => {
            DefinitionDesBarresStatistiquesConcours.getDefinitionDesBarresStatistiquesConcours(payload)
                .then((response): void => {
                    commit('SET_INFOS_STATISTIQUES_CONCOURS', response.data.data)
                    commit('SET_LOADING', false)
                    resolve(response)
                })
                .catch((error): void => {
                    commit('SET_LOADING', false)
                    commit('SET_ERROR', getError(error))
                    reject(error)
                })
        })
    }
}

export const getters = {
    // tableau non trié, utiliser pour watch les changements
    stateInfosStatistiquesConcours: (state: StateDefinitionDesBarresStatistiquesConcours): any => {
        return state.infosStatistiquesConcours
    },
    infosStatistiquesConcours:
        (state: StateDefinitionDesBarresStatistiquesConcours): any =>
            (barres: any, nb_classe: number, barres_total = 0): any => {
                // infos des candidats
                const infos = state.infosStatistiquesConcours

                const nb_candidats = infos.length
                const nb_candidats_recu = infos.filter((candidat: { recu: number }) => {
                    return candidat.recu === 1
                }).length
                const meilleure_note = [0, 0]
                // Barre principale
                const barre_selected = barres_total
                const barre_secondaire = barre_selected === 0 ? 1 : 0

                const infosRejet = {
                    noteEliminatoire: 0,
                    rejetBarre1: 0,
                    rejetBarre2: 0,
                    rejetDeuxBarres: 0,
                    elimines: 0
                }

                const barre1: any = []
                // barre2, candadidats ayant validé la 2 eme barres
                const barre2: any = []
                // barre2, candadidats n'ayant pas validé la 2 eme barres
                const barre3: any = []

                infos.forEach((candidat: any) => {
                    if (candidat?.bar_rule_results) {
                        // recup des notes du candidats
                        const notesCandidat: Array<number> = Object.entries(candidat.bar_rule_results)
                            .filter(([id]: any) => barres.map((bar: any) => bar.id.toString()).includes(id))
                            .map(([, value]: any) => value);
                        // console.log(notesCandidat)
                        // calcul premiere barre
                        if (notesCandidat[barre_selected] !== null) {
                            // recuperation de la note max
                            if (meilleure_note[barre_selected] < notesCandidat[barre_selected]) {
                                meilleure_note[barre_selected] = notesCandidat[barre_selected]
                            }
                        }

                        // incrementation des infos globales dans candidat.infos afin d'alimenter les infos globales candidat
                        const infos = candidat.infos
                        if (infos) {
                            if (infos.rejectedBeforePassBar) {
                                infosRejet.noteEliminatoire++
                            } else if (infos.rejectionReasons?.length) {
                                switch (infos.rejectionReasons.length) {
                                    case 1:
                                        infosRejet.rejetBarre1++
                                        break
                                    case 2:
                                        infosRejet.rejetDeuxBarres++
                                        break
                                }
                            }
                        }
                    }
                })

                infos.forEach((candidat: any) => {
                    if (candidat?.bar_rule_results) {
                        // recup des notes du candidats
                        const notesCandidat: Array<number> = Object.entries(candidat.bar_rule_results)
                            .filter(([id]: any) => barres.map((bar: any) => bar.id.toString()).includes(id))
                            .map(([, value]: any) => value);
                        const r = Math.floor(notesCandidat[barre_selected] / nb_classe)

                        // calcul premiere barre
                        if (notesCandidat[barre_selected] !== null) {
                            if (!barre1[r]) {
                                barre1[r] = 0
                            }
                            // creation d'un tableau de chiffre barre1[r] correcpond a la valeur X du tableau, on incremente +1 pour ajouter un candidat
                            if (notesCandidat[barre_selected] >= meilleure_note[barre_selected]) {
                                barre1[r - 1] += 1
                            } else if (notesCandidat[barre_selected] < meilleure_note[barre_selected]) {
                                barre1[r] += 1
                            }
                        }
                        // calcul deuxieme barre, on divise en deux, si >= a la barre de validation, alors on ajoute un candidat dans la barre de validation sinon, barre invalidation
                        if (notesCandidat[barre_secondaire] !== null) {
                            if (meilleure_note[barre_secondaire] < notesCandidat[barre_secondaire]) {
                                meilleure_note[barre_secondaire] = notesCandidat[barre_secondaire]
                            }
                            if (!barre2[r]) {
                                barre2[r] = 0
                            }
                            if (
                                barres[barre_secondaire] &&
                            notesCandidat[barre_secondaire] >=
                                barres[barre_secondaire].value
                            ) {
                                if (!barre2[r]) {
                                    barre2[r] = 0
                                }
                                if (notesCandidat[barre_selected] >= meilleure_note[barre_selected]) {
                                    barre2[r - 1] += 1
                                } else if (notesCandidat[barre_selected] < meilleure_note[barre_selected]) {
                                    barre2[r] += 1
                                }
                            } else if (
                                barres[barre_secondaire] &&
                            notesCandidat[barre_secondaire] <
                                barres[barre_secondaire].value
                            ) {
                                if (!barre3[r]) {
                                    barre3[r] = 0
                                }
                                if (notesCandidat[barre_selected] >= meilleure_note[barre_selected]) {
                                    barre3[r - 1] += 1
                                } else if (notesCandidat[barre_selected] < meilleure_note[barre_selected]) {
                                    barre3[r] += 1
                                }
                            }
                        }
                    }
                })

                // valeur x = note maximale de la barre
                const axeX = getX(meilleure_note[barre_selected], nb_classe)
                const barre_name1 = 'Tous les candidats'
                const barre_name2 = barres[barre_secondaire]
                    ? 'Candidats au dessus de la barre ' + barres[barre_secondaire].name
                    : null
                const barre_name3 = barres[barre_secondaire]
                    ? 'Candidats en dessous de la barre ' + barres[barre_secondaire].name
                    : null

                infosRejet.elimines =
                infosRejet.noteEliminatoire +
                infosRejet.rejetBarre1 +
                infosRejet.rejetDeuxBarres

                return {
                    nb_candidats: nb_candidats,
                    nb_candidats_recu: nb_candidats_recu,
                    infosrejet: infosRejet,
                    axeX: axeX.map((x: any) => Math.ceil(x)),
                    barre1: barre1,
                    barre2: barre2,
                    barre3: barre3,
                    barre_name1: barre_name1,
                    barre_name2: barre_name2,
                    barre_name3: barre_name3,
                    meilleure_note: meilleure_note
                }
            },

    graphIsLoading: (state: StateDefinitionDesBarresStatistiquesConcours): boolean => {
        return state.graphIsLoading
    }
}
